export default "__VITE_ASSET__JcFE4rMd__"